var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"light-blue white--text","to":_vm.to,"icon":"","target":_vm.target}},[_c('v-icon',[_vm._v("fa-external-link-alt")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }